module.exports = __webpack_public_path__ + "img/UTANTE-7.7ca679f1.jpg";